import { useAuthContext } from '@/contexts/auth-context/auth-context';
import type { Permission } from '../constants/permissions.constant';

export function useHasPermission(
  permission: Permission | Permission[]
): boolean {
  const { user } = useAuthContext();

  if (!user || !user.permissions) return false;

  const permissions = Array.isArray(permission) ? permission : [permission];
  return permissions.some(p => user.permissions.includes(p));
}

export function useHasAllPermissions(permissions: Permission[]): boolean {
  const { user } = useAuthContext();

  if (!user || !user.permissions) return false;

  return permissions.every(p => user.permissions.includes(p));
}

export function useHasAnyPermission(permissions: Permission[]): boolean {
  return useHasPermission(permissions);
}
